import styles from './third.module.css';
import FullSize from '../../components/full-size';
import { useNavigate } from 'react-router-dom';
import AnswerForm from '../../components/answer-form';
import { getNextLevelUrl, isLevelAllowed, markLevelCompleted } from '../../helper';
import { useEffect, useState } from 'react';
import HintBox from '../../components/hint-box';

function Third() {
  const LEVEL = 3;
  const navigate = useNavigate();
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate('/cheating');
    }
  }, [navigate]);

  const onSubmit = (answer: string) => {
    if (answer === "2780" || answer === "2708" || answer === "9898") {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setShake(true);
    }
  }

  return (
    <FullSize bgColor="transparent">
      <div className={styles.wrapper}>
        <div className={styles.formWrapper}>
        <h1 className={styles.title}>Level 3</h1>
          <AnswerForm onSubmit={onSubmit} type="number" shake={shake} setShake={setShake} />
        </div>
      </div>
      <HintBox hintText="Gå ut på skattjakt och hitta ett objekt. Därefter är det lämpligt att låtsas att ni är blinda." />
    </FullSize>
  );
}

export default Third;
